// extracted by css-extract-rspack-plugin
export default {"Box":"milestone-module__Box__CREM0rt"};